import { ResetPasswordInput } from 'dtos/users/ResetPasswordInput';
import { makeAutoObservable, runInAction } from 'mobx';
import { createForm } from 'forms/resetPasswordForm';
import { Match } from 'navigo';
import { LoadStatus } from 'utils/types';
import { serverUri } from 'utils/config';

export class ResetPasswordStore {
  private token?: string;

  form = createForm();
  status: LoadStatus = 'none';
  message?: string;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  activate(match: Match) {
    this.token = match?.data?.token;
    this.status = 'none';
    this.message = undefined;
    this.form.reset();
  }

  async resetPassword() {
    this.status = 'loading';
    this.message = undefined;
    const { isValid } = await this.form.validate({ showErrors: true });
    if (!isValid) {
      return;
    }
    const { newPassword } = this.form.values();
    const dto: ResetPasswordInput = {
      token: this.token || '',
      password: newPassword,
    };
    try {
      const response = await fetch(`${serverUri}/user/password/reset`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dto),
      });
      if (!response.ok) throw new Error('Error changing password');
      this.form.reset();
      runInAction(() => {
        this.status = 'success';
        this.message = undefined;
      });
    } catch (err) {
      runInAction(() => {
        this.status = 'error';
        this.message = 'Unable to change password. The password-reset email may have expired.';
      });
    }
  }
}
